import PermissionGroupContainer from 'modules/permissions/pages/settings/PermissionGroupContainer'

const PermissionsShowRootPage = () => {
  return <PermissionGroupContainer />
}

export default PermissionsShowRootPage
